import React from "react";
import styled from "styled-components";
import { PlusGrayIcon } from "../../../../CommonUI/Icon/PlusGrayIcon";
import { StateManager } from "../../../../rule-engine-core/Common/StateManager";
import { ValueTableRuleEditContext } from "../../../../rule-engine-core/Rule/Table/Value/ValueTableRuleEditContext";
import { ValueTableConfiguration } from "../../../../rule-engine-core/Rule/Table/Value/ValueTableConfiguration";
import { XValueTableRuleColumnHeader } from "./ValueTableRuleColumnHeader";

import {
    RuleTableHeaderActionColumn,
    RuleTableHeaderSplit,
    RuleTableIndexColumn,
} from "../../../DesignUI/CommonStyles";
import { XResultColumn } from "../../CommonUI/XResultColumn";
import { TestContext } from "../../../../CommonUI/Testing/TestContext";
import { UIStyleConstants } from "../../../../rule-engine-core/Common/UIStyleConstants";

interface RuleTableHeaderProps {
    ruleDefinition: ValueTableConfiguration;
    editContext: ValueTableRuleEditContext;
}

export const ValueRuleTableHeader = (props: RuleTableHeaderProps) => {
    const { ruleDefinition, editContext } = props;

    const testContext = React.useContext(TestContext);

    const onAddNewColumnHeader = () => {
        if (testContext) return;
        ruleDefinition.addColumn();
        StateManager.propertyChanged(ruleDefinition, "columns");
    };

    const onAddNewResultColumnHeader = () => {
        if (testContext) return;
        ruleDefinition.addResultColumn();
        StateManager.propertyChanged(ruleDefinition, "resultColumns");
    };

    return (
        <>
            {/* header title */}
            <RuleTableIndexColumn />
            <ValueTableRulesLabel length={ruleDefinition.columns.length + 1}>Rules</ValueTableRulesLabel>
            <ValueTableRulesLabel length={ruleDefinition.resultColumns.length + 2}>Result</ValueTableRulesLabel>

            <RuleTableIndexColumn />
            {ruleDefinition.columns.map((ruleColumn, idx) => {
                return (
                    <XValueTableRuleColumnHeader
                        key={idx}
                        ruleDefinition={ruleDefinition}
                        editContext={editContext}
                        ruleColumn={ruleColumn}
                    />
                );
            })}
            <RuleTableHeaderActionColumn
                onClick={onAddNewColumnHeader}
                data-testid="btn-value-table-add-new-column"
            >
                {testContext ? null : <PlusGrayIcon />}
            </RuleTableHeaderActionColumn>
            {ruleDefinition.resultColumns.map((resultCol) => {
                return (
                    <XResultColumn
                        ruleDefinition={ruleDefinition}
                        resultColumn={resultCol}
                        key={resultCol._id}
                    />
                );
            })}

            <RuleTableHeaderActionColumn
                onClick={ruleDefinition.canChangeOutputs ? onAddNewResultColumnHeader : undefined}
                data-testid="btn-value-table-add-new-result-column"
            >
                {ruleDefinition.canChangeOutputs && !testContext ? <PlusGrayIcon /> : null}
            </RuleTableHeaderActionColumn>
            <RuleTableHeaderActionColumn />

            {/* splits */}
            <RuleTableIndexColumn height={1} />
            {ruleDefinition.columns.map((_, idx) => (
                <RuleTableHeaderSplit key={idx} />
            ))}
            <RuleTableHeaderSplit width={24} />
            {ruleDefinition.resultColumns.map((resultCol) => {
                return <RuleTableHeaderSplit key={resultCol._id} />;
            })}

            <RuleTableHeaderSplit width={24} />

            <RuleTableHeaderSplit width={24} />
        </>
    );
};

const ValueTableRulesLabel = styled.div<{ length: number }>`
    grid-column: span ${(props) => props.length};
    border-bottom: 2px solid ${UIStyleConstants.BLUE_COLOR};

    padding-top: 10px;

    color: ${UIStyleConstants.BLUE_COLOR};

    font-size: 8px;
    font-style: normal;
    font-weight: 500;
    line-height: 11px;
    letter-spacing: 0.10000000149011612px;
    text-align: left;
`;
